import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { orderbyDate } from '@helpers/helper.novelty'
import { ElementHTML } from '@helpers/helper.rendering'
import { setActiveNovelties, setActiveTags } from '@slices/noveltiesSlice'
import React, { useEffect, useState } from 'react'
import { Button, Col, Container, Row } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { Novelty, RealEstateDataPageComponentData } from 'types'

const NoveltiesJumbotron4 = (props: RealEstateDataPageComponentData) => {
  const {
    title,
    titleElement,
    subtitle,
    subtitleElement,
    titleColor,
    subtitleColor,
    titleHexa,
    subtitleHexa,
    backgroundColor,
    backgroundHexa,
  } = props
  const {
    global_data: { id: siteId },
  } = props

  const [isMounted, setIsMounted] = useState(false)

  const { data: allBlogData, isLoading } = useGetBlogsQuery({ site: siteId })

  const [isActiveFilterButton, setIsActiveFilterButton] = useState(false)

  useEffect(() => {
    setIsMounted(true)
  }, [])

  const dispatch = useDispatch()

  const { tags_active } = useSelector(
    (state: { novelties: { tags_active: number[]; novelties_active: Novelty[] } }) =>
      state.novelties,
  )!

  const toggleTag = (id: number) => {
    setIsActiveFilterButton(true);
    const isTagActive = tags_active.includes(id);

    if (isTagActive) {
      const updatedTags = tags_active.filter((e) => e !== id);
      dispatch(setActiveTags(updatedTags));

      if (updatedTags.length === 0) {
        dispatch(setActiveNovelties(allBlogData?.news));
        setIsActiveFilterButton(false);
      }
    } else {
      dispatch(setActiveTags([...tags_active, id]));
    }
  }

  const filterNoveltiesAction = () => {
    if (tags_active.length === 0) {
      setIsActiveFilterButton(false)
      dispatch(setActiveNovelties(allBlogData?.news))
      return
    }

    const response = allBlogData?.news?.filter(novelty =>
      novelty.tags.some(tag => tags_active.includes(tag.id))
    ) ?? []

    setIsActiveFilterButton(false)
    dispatch(setActiveNovelties(response))
  }

  useEffect(() => {
    if (allBlogData?.news) {
      dispatch(setActiveNovelties(orderbyDate(allBlogData.news)))
    }
  }, [allBlogData])

  return (
    isMounted && (
      <section
        className={`p-y-config novelties_jumbotron_4 ${backgroundColor}`}
        style={backgroundColor === 'background-picker' ? { backgroundColor: backgroundHexa } : {}}
      >
        <Container fluid>
          <ElementHTML
            className={`mb-4 ${titleColor} text-center`}
            children={title ?? ''}
            elementType={titleElement ?? 'h2'}
            style={titleColor === 'text-picker' ? { color: titleHexa } : {}}
          />
          <Row className={`d-flex align-items-center justify-content-center`}>
            <Col
              xs={12}
              lg={10}
            >
              <ElementHTML
                className={`mb-4 ${subtitleColor} text-center`}
                children={subtitle ?? ''}
                elementType={subtitleElement ?? 'p'}
                style={subtitleColor === 'text-picker' ? { color: subtitleHexa } : {}}
              />
            </Col>
          </Row>
          <Row className="mt-5">
            <Col
              xs={12}
              lg={6}
            >
              <div className="div_search d-flex justify-content-between align-items-center mb-5 mb-lg-0">
                <i
                  className="icon-label-solid mx-3"
                  style={{ fontSize: '1.5rem', color: 'var(--primaryColor)' }}
                />
                <div className="div_pills flex-wrap">
                  {tags_active.map((element, index) => (
                    <span
                      key={index}
                      className="animate__animated animate__fadeInRight pill btn btn-secondary-outlined me-2 mb-1 mt-2 mt-lg-1"
                    >
                      {allBlogData?.tags.find((item) => item.id === element)?.name}
                      <i
                        onClick={() => toggleTag(element)}
                        className="icon-close-light ms-2"
                        style={{ fontSize: '.8rem' }}
                      />
                    </span>
                  ))}
                </div>
                <div className="d-flex p-2">
                  <button
                    className="btn-clear me-3 d-none d-md-block cursor-pointer"
                    onClick={() => {
                      dispatch(setActiveTags([]))
                      dispatch(setActiveNovelties(allBlogData?.news))
                      setIsActiveFilterButton(false)
                    }}
                  >
                    Limpiar
                  </button>
                  <Button
                    variant="primary"
                    disabled={!isActiveFilterButton}
                    className={`d-flex align-items-center`}
                    onClick={() => filterNoveltiesAction()}
                  >
                    <span
                      className="d-none d-md-inline"
                      style={{ color: 'inherit' }}
                    >
                      FILTRAR
                    </span>
                    <i className="icon-search ms-0 ms-md-3"></i>
                  </Button>
                </div>
              </div>
            </Col>
            <Col
              xs={12}
              lg={6}
            >
              <div className="div_etiquetas flex-wrap d-flex justify-content-center justify-content-lg-end">
                {isLoading
                  ? [1, 2, 3].map((index) => (
                      <div
                        className="me-3 mb-2 d-inline-block"
                        key={index}
                      >
                        <span
                          key={index}
                          className="animate__animated animate__fadeInDown cursor-pointer pill skeleton btn btn-primary me-2 mt-2 mt-lg-0"
                        >
                          ...
                        </span>
                      </div>
                    ))
                  : allBlogData?.tags.map((tag, index) =>
                      tags_active.find((e) => e === tag.id) ? (
                        ''
                      ) : (
                        <Button
                          variant="outline-primary"
                          className="animate__animated animate__fadeInDown me-2 mt-2 mt-lg-0 btn btn-secondary-outlined mb-2"
                          key={index}
                          onClick={() => toggleTag(tag.id)}
                        >
                          {tag.name}
                        </Button>
                      ),
                    )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    )
  )
}

export default NoveltiesJumbotron4
